import classnames from 'classnames';
import React, { Suspense, useLayoutEffect } from 'react';
import renderSVG from '@Controls/render-icon';
import { __ } from '@wordpress/i18n';
import lazyLoader from '@Controls/lazy-loader';
import { RichText } from '@wordpress/block-editor';
import styles from './editor.lazy.scss';

const Render = (props, state) => {
	useLayoutEffect(() => {
		styles.use();
		return () => {
			styles.unuse();
		};
	}, []);
	props = props.parentProps;
	const { attributes, setAttributes } = props;
	const { question, answer, icon, iconActive, layout, headingTag } =
		attributes;

	const faqRenderIcon = () => {
		return (
			<>
				<span className="wpsp-icon wpsp-faq-icon-wrap">
					{renderSVG(icon)}
				</span>
				<span className="wpsp-icon-active wpsp-faq-icon-wrap">
					{renderSVG(iconActive)}
				</span>
			</>
		);
	};
	const faqRenderHtml = () => {
		return (
			<div className="wpsp-faq-child__wrapper">
				<div className="wpsp-faq-item" role="tab" tabIndex="0">
					<div className="wpsp-faq-questions-button wpsp-faq-questions">
						{'accordion' === layout && faqRenderIcon()}
						<RichText
							tagName={'span' !== headingTag ? headingTag : 'div'}
							placeholder={__('Question')}
							value={question}
							onChange={(value) =>
								setAttributes({ question: value })
							}
							className="wpsp-question"
							multiline={false}
							allowedFormats={[
								'core/bold',
								'core/italic',
								'core/strikethrough',
							]}
						/>
					</div>
					<div className="wpsp-faq-content">
						<span>
							<RichText
								tagName="p"
								placeholder={__('Answer')}
								value={answer}
								onChange={(value) =>
									setAttributes({ answer: value })
								}
								multiline={false}
								allowedFormats={[
									'core/bold',
									'core/italic',
									'core/strikethrough',
									'core/link',
								]}
							/>
						</span>
					</div>
				</div>
			</div>
		);
	};

	return (
		<div
			className={classnames(
				'wpsp-faq-child__outer-wrap',
				`wpsp-block-${props.clientId.substr(0, 8)}`,
				props.isSelected && false !== state.isFocused
					? 'wpsp-faq__active'
					: ''
			)}
		>
			<Suspense fallback={lazyLoader()}>{faqRenderHtml()}</Suspense>
		</div>
	);
};
export default React.memo(Render);
